import objectEach from 'fast-loops/lib/objectEach';

import createSubscription from './connection/createSubscription';

export default function render(renderer) {
  if (!renderer.updateSubscription) {
    renderer.nodes = {};

    renderer.updateSubscription = createSubscription(renderer);
    renderer.subscribe(renderer.updateSubscription);

    // simulate rendering to ensure all styles rendered prior to
    // calling FelaDOM.render are correctly injected as well
    objectEach(renderer.cache, renderer._emitChange);
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/render.js
// module id = 346
// module chunks = 0